import React, { useCallback } from "react";
import { Button, Icon, styled } from "@washingtonpost/wpds-ui-kit";
import { Close } from "@washingtonpost/wpds-assets";
import PropTypes from "prop-types";
import { VideoEvents } from "../../globals";
import { useVideoElementRefContext } from "../../orca/contexts/VideoElementRefContext";
import { keyDownButtonWrapper } from "../../../utils/keydown-wrapper";

const GoBackButtonWrapper = styled("span", {
  display: "none",
  zIndex: 999,
  cursor: "pointer",
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  lineHeight: 0,
  flexShrink: 0,

  "&:focus-visible": {
    outline: "2px solid #ffffff",
    outlineOffset: "50%"
  },

  "@sm": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

const closeButtonCss = {
  backgroundColor: "rgba(0, 0, 0, 0.6) !important",
  color: "#ffffff !important",
  borderRadius: "50%",
  width: "32px",
  height: "32px",
  minWidth: "32px",
  minHeight: "32px",
  border: "none",
  padding: 0,
  "& svg": {
    color: "#ffffff !important",
    fill: "#ffffff !important"
  },
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.6) !important"
  }
};

export const GoBackButton = ({
  isCarousel,
  closeCarousel,
  closeFullscreen
}) => {
  const videoElementRef = useVideoElementRefContext();

  const handleBack = useCallback(
    e => {
      e?.stopPropagation?.();

      if (isCarousel) {
        closeCarousel();
        return;
      }

      closeFullscreen();

      const fullscreenEvent = new Event(VideoEvents.UNFULLSCREEN);
      videoElementRef.current.dispatchEvent(fullscreenEvent);
    },
    [isCarousel, closeCarousel, closeFullscreen, videoElementRef]
  );

  return (
    <GoBackButtonWrapper
      role="button"
      aria-label="Close video player"
      className="focus-highlight"
      tabIndex={0}
      onClick={handleBack}
      onKeyDown={e =>
        keyDownButtonWrapper(e, () => {
          handleBack(e);
        })
      }
      data-testid="go-back-button"
    >
      <Button
        aria-hidden={true}
        variant="secondary"
        icon="center"
        css={closeButtonCss}
        tabIndex={-1}
      >
        <Icon size="100">
          <Close />
        </Icon>
      </Button>
    </GoBackButtonWrapper>
  );
};

GoBackButton.propTypes = {
  isCarousel: PropTypes.bool,
  closeCarousel: PropTypes.func,
  closeFullscreen: PropTypes.func
};
